// Dependency-free so it can be unit tested under node and reused by the
// dashboard's plan-change confirmation.

function cadenceText(months) {
  const count = Number(months) || 0;
  if (count === 0 || count === 12) {
    return 'per year';
  }
  if (count === 1) {
    return 'per month';
  }
  return `every ${count} months`;
}

// The statement a customer agrees to when changing tier from the dashboard.
// Mirrors SubscriptionDisclosureText.tier_change_statement on the server.
export function tierChangeStatement({
  fromName,
  toName,
  priceText,
  renewalIntervalMonths,
  now,
  renewalDate,
}) {
  let charged = 'charged today';
  if (!now) {
    charged = renewalDate
      ? `charged on my renewal date, ${renewalDate}`
      : 'charged on my next renewal date';
  }
  return `I agree to change my ${fromName} to the ${toName} at ${priceText} ${cadenceText(renewalIntervalMonths)}, ${charged}, and that it will continue to automatically renew and charge my card on file until I change or cancel it from my account.`;
}

export default tierChangeStatement;
